import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { Toast  } from "../../common/message";
import dayjs from "dayjs";
import { getRandom } from "../../common/RandomNumber";

const Login = () => {
  Axios.defaults.withCredentials = true; // 세션을 관리하고자하는 파일에 꼭 작성
  const navigate = useNavigate();

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
  
  const [userIDsave, setUserIDSave] = useState(false);

  const [value, setValue] = useState({});
  const valueHandle = (e)=>{
    setValue({ ...value, [e.target.id]: e.target.value })
  }

  useEffect(()=>{
    document.title = '베이프마켓 - 로그인';

    if(Boolean(window.localStorage.getItem('login_save'))){
      setUserIDSave(true);
      document.getElementById('userid').value = window.localStorage.getItem('login_id');
      setValue({ ...value, userid: document.getElementById('userid').value = window.localStorage.getItem('login_id') })
    }
  }, [])

  // 로그인 성공시 로딩창 보이기
  const [loginLoading, setLoginLoading] = useState(false);

  // 로그인 함수
  const login = async (e) => {
    e.preventDefault();
    
    if(!value.userid) return Toast.fire({ icon: "warning", text: "아이디를 입력해 주세요." });
    if(!value.userpw) return Toast.fire({ icon: "warning", text: "비밀번호를 입력해 주세요." });

    await Axios.post(`/api/login/join`, {
      id: value.userid, pw: value.userpw , firstLoginDate: toDay.time
    })
    .then((res) => {
      if (res.data.value) {
        // 로그인 성공시 로컬 스토리지에 초기값 저장
        window.sessionStorage.setItem('basicID', res.data.userid);
        window.sessionStorage.setItem('basicName', res.data.name);
        window.sessionStorage.setItem('basicPermission', res.data.permission);
        window.sessionStorage.setItem('basicPosition', res.data.position);
        window.sessionStorage.setItem('basicStore', res.data.store);
        // window.sessionStorage.setItem('basicDate', toDay.date);
        // window.sessionStorage.setItem('basicTime', toDay.time);

        if(userIDsave){
          window.localStorage.setItem('login_id', res.data.userid);
        } else {
          window.sessionStorage.removeItem('login_save');
          window.sessionStorage.removeItem('login_id');
        }

        setLoginLoading(true);
        const timer1 = setTimeout(()=>{
          navigate("/sale");
          return ()=>{
            clearTimeout(timer1);
          }
        }, getRandom(1000, 2000))

      } else {
        setLoginLoading(false);
        return Toast.fire({ icon: "error", titleText: res.data.title, text: res.data.message });
      }
    })
    .catch((err)=>{
      Toast.fire({ icon: 'error', text: err, titleText: '오류가 발생했습니다'});
    });
  };
  
  return (
    <div className="bg-[#1E1E1E] flex flex-col duration-150 justify-center p-3 items-center h-screen text-sm">
      <div className={`
          gap-3 shadow-inner duration-150 shadow-[#3E3E3E]/80 bg-[#2E2E2E] border-[1px] border-[#3E3E3E]/80 rounded-md p-3 w-full md:w-[450px] md:h-[500px]
          ${loginLoading && 'border-yellow-500 border-[2px] animate-pulse'}
        `}>
        {/* 틀 안에 메인 기능 */}
        <div className={`
          flex flex-col justify-center items-center h-full duration-150
          ${loginLoading ? 'hidden' : 'inline'}
        `}>
          {/* <img className="w-32 md:hidden inline" src="./vapemarket_logo.png" alt="logo" loading="lazy" /> */}
          <div className='lg:min-w-[305px] p-3 text-2xl md:text-3xl text-center text-yellow-400' style={{ fontFamily: 'Nosifer, cursive'}}>
            <p className='mb-10'>
              VapeMarket
            </p>
          </div>
          <form className="flex flex-col gap-3 p-3 w-full" autoComplete="off">
            <input className="p-3 rounded-lg hover:rounded-sm hover:bg-[#3E3E3E]/80 focus:rounded-sm w-full bg-[#1E1E1E]/50 focus:bg-[#1E1E1E] outline-none border-[1px] border-[#3E3E3E] duration-150 focus:border-transparent" id="userid" type="text" placeholder="User ID" onChange={ valueHandle } />
            <input className="p-3 rounded-lg hover:rounded-sm hover:bg-[#3E3E3E]/80 focus:rounded-sm w-full bg-[#1E1E1E]/50 focus:bg-[#1E1E1E] outline-none border-[1px] border-[#3E3E3E] duration-150 focus:border-transparent" id="userpw" type="password" placeholder="User Password" onChange={ valueHandle } />
            <div className="w-full flex justify-end">
              <div className="flex justify-end items-center mb-5 mt-[-0.5rem] duration-150 p-1 bg-[#2E2E2E] focus:bg-[#1E1E1E] px-3 py-2 rounded-md">
                <input id="default-checkbox" type="checkbox" className="w-4 h-4 outline-none rounded-md cursor-pointer bg-gray-700"
                checked={userIDsave ? true : false} onChange={()=>{
                  setUserIDSave(!userIDsave);
                  window.localStorage.setItem('login_save', !userIDsave);
                }}/>
                <label htmlFor="default-checkbox" className="ml-2 text-sm font-medium text-gray-300 cursor-pointer">
                  Remember Me
                </label>
              </div>
            </div>
            <button type="submit" 
            className="p-3 rounded-md w-full transition duration-150 hover:bg-[#1E1E1E]/80 active:bg-[#1E1E1E]/60 bg-[#1E1E1E] outline-none" 
            onClick={login}>
              LogIn
            </button>
            <button 
            className="p-3 rounded-md w-full transition duration-150 hover:bg-[#1E1E1E]/80 active:bg-[#1E1E1E]/60 bg-[#1E1E1E] outline-none" 
            onClick={(e)=>{        
              e.preventDefault();
              navigate('/register');
            }}>
              Register
            </button>
          </form>
        </div>

        {/* 로딩 기능 구현할 부분 */}
        <div className={`
          duration-150 flex flex-col justify-center items-center text-center w-full h-full
          ${loginLoading ? 'inline' : 'hidden'}
        `}>
          <div className='flex flex-col justify-center items-center h-full py-20'>
            <img className="w-32 animate-bounce duration-150" src="./vapemarket_logo.png" alt="logo" loading="lazy" />
            <p className="text-base" style={{ fontFamily: 'Gugi, cursive'}}>필요한 정보들을 확인 중입니다..</p>
            <p className="text-base" style={{ fontFamily: 'Gugi, cursive'}}>조금만 기다려주세요</p>
          </div>
        </div>

      </div>
      
    </div>
  );
};
export default Login;